/* eslint-disable react-hooks/exhaustive-deps */
import { SuccessFetch } from "../types/billAdjustmentTypes"
import { useApi } from "utils"
import { adjustmentFreightStore } from "../utils/adjustmentFreightStore"
import moment from "moment";
import { useEffect } from "react";

interface CodeType {
    trx_code:string
}

export function CodeAdjustmentFreight(){
    const api = useApi();
    const {
        adj_code,
        setAdjCode
    } = adjustmentFreightStore()

    const fetchData = () => {
        const params = {
            transaction_date: moment().format('YYYY-MM-DD'),
        }

        api.get("probill/generate_adjustment_code", { params })
        .then((res) => {
            const response: SuccessFetch<CodeType> = res.data;
            let data = response.payload;
            setAdjCode(data.trx_code)
        })
        .catch(() => {
            setAdjCode('')
        })
        .finally(() => {})
    }

    useEffect(()=>{
        fetchData()
        // eslint-disable-next-line
    },[])

    return <div>{adj_code}</div>
}
